import { Injectable } from '@angular/core';
import { Response, Http, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import {
  NonTransactionalFlow,
  BasicPageInfo,
} from '../model/interfaces/non-transactional-flow.interface';
import { LoaderService } from './loader.service';
import { environment } from 'environments/environment';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { SxHttpService } from './sxHttp.service';
import { FlowElement, FlowRulePostRequest } from './productFlow.service';
import { Rule } from '../model/interfaces/rule.interface';

export interface NonTransactionalRequest {
  endpoint: string;
  verb: 'get' | 'post' | 'delete';
  payload?: any;
}

export const NonTransactionalFlowStantdardKey = 'nonTransactionalFlow';

@Injectable()
export class NonTransactionalFlowService {
  socUrl : string = 'api/nonTransactionalFlow';

  constructor(
    private http: Http,
    private sxHttp: SxHttpService,
    private loaderService: LoaderService
  ) {
  }

  createOrUpdatePage(id: string, page: any): Observable<Response> {
    const req = <NonTransactionalRequest> {
      endpoint: `UpsertPageLegacy/${id}`,
      verb: 'post',
      payload: page
    };
    
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`/${this.socUrl}/Handle`, req)
      .map(response => response.json().data as Response)
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  detelePage(arg: { id: string; pageId: string; }) : Promise<any>{
    const req = <NonTransactionalRequest> {
      endpoint: `DeletePageLegacy/${arg.id}/${arg.pageId}`,
      verb: 'delete',
      payload: arg
    };
    
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`/${this.socUrl}/Handle`, req)
      .map(response => response.json().data as Response)
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader())
      .toPromise();
  }


  getFlow(flowId: string, pageId: string): Observable<Response> {
    const req = <NonTransactionalRequest> {
      endpoint: `GetFlow/${flowId}/${pageId}`,
      verb: 'get',
    };
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`${this.socUrl}/Handle`, req)
      .map(response => response.json().data as Response)
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  deleteFlow(flowId: string): Observable<Response> {
    const req = <NonTransactionalRequest> {
      endpoint: `DeleteFlow/${flowId}`,
      verb: 'delete',
    };
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`${this.socUrl}/Handle`, req)
      .map(response => response.json().data as Response)
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  getAll(): Observable<NonTransactionalFlow[]> {
    const req = <NonTransactionalRequest> {
      endpoint: `ListFlows/`,
      verb: 'get',
    };
    this.loaderService.mostrarLoader();
    return this.sxHttp  
      .post(`${this.socUrl}/Handle`, req)
      .map(response => response.json().data as NonTransactionalFlow[])
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  createNonTransactionalFlow(description: Object): Observable<string> {
    const req = <NonTransactionalRequest> {
      endpoint: `CreateFlow/`,
      verb: 'post',
      payload: description
    };
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`${this.socUrl}/Handle`, req)
      .map(response => response.json().data as string)
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  getFlowPages(id: string): Observable<BasicPageInfo[]> {
    const req = <NonTransactionalRequest> {
      endpoint: `ListPages/${id}`,
      verb: 'get',
    };
    this.loaderService.mostrarLoader();
    return this.sxHttp
      .post(`${this.socUrl}/Handle`, req)
      .map(response => response.json().data as BasicPageInfo[])
      .catch((err) => this.errorHandler(err))
      ._finally(() => this.loaderService.ocultarLoader());
  }

  getNonTransactionalRules(flowId: string) : Observable<FlowElement[]>{
    const url = `${this.socUrl}/Rules/${flowId}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as FlowElement[])
      .catch(this.errorHandlerPropmise);  
  }

  getInteractionEventByCode(flowId: any, codCommand: string) : Observable<Rule>{
    const url = `${this.socUrl}/Rules/${flowId}/${codCommand}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as Rule)
      .catch(this.errorHandler);
  }

  createOrUpdateInteractionEvent(flowId: string, request: FlowRulePostRequest) : Promise<Rule> {
    const url = `${this.socUrl}/Rules/${flowId}`;

    return this.sxHttp.post(url, request)
      .toPromise()
      .then(response => response.json().data as Rule)
      .catch(this.errorHandlerPropmise);  
    }

  errorHandlerPropmise(error: any): Promise<any> {
      console.error('Ocurrió un error', error);
      return Promise.reject(error.message || error);
    }
 
    errorHandler(error: Response | any) {
    console.error(error);
    const result = {
      codigo: null,
      mensaje: error.toString(),
    };
    return Observable.throw(result);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/non-transactional-flow.service.ts